import * as yup from "yup";
import { useTranslation } from "next-i18next";

export const useContactsValidation = () => {
  const { t } = useTranslation();

  return yup.object({
    name: yup.string().required(t("errors:field_required.name")),
    email: yup.string().required(t("errors:field_required.email")),
    subject: yup.string().required(t("errors:field_required.default")),
    message: yup.string().required(t("errors:field_required.default")),
    agreement: yup
      .boolean()
      .required(t("errors:field_required.default"))
      .oneOf([true], t("errors:field_required.default"))
  });
};
